var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-info"},[_c('h3',[_vm._v("\n    "+_vm._s(_vm.info.address.location.fullLocation)+" •\n    "+_vm._s(_vm.info.contact.phone)+" •\n    "+_vm._s(_vm.info.contact.email)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0a78d42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactInfo.vue
// module id = null
// module chunks = 